// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3xuM2","content":"LoadingAlert_content__iJ7QO"};